import { AutoComplete, Button, Card, Col, Descriptions, Divider, Flex, Form, Grid, Input, InputNumber, message, Modal, Popconfirm, Radio, Row, Select, Space, Steps, Typography, Upload } from "antd";
import { useEffect, useState } from "react";
import RenderIf from "../../components/RenderIf";
import { Icon } from "@iconify/react/dist/iconify.js";
import pallete from "../../utils/pallete";
import { Link, useNavigate, useParams } from "react-router";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { surveyService } from "../../services/survey.service";
// import UploadFileRenderer from "../../components/FileUploadRenderer";
import { API_BASE_URL } from "../../config/api.config";
import { MAX_FILE_SIZE } from "../../utils/const";
import { cancelReason, skemaPembayaran, sumberAir } from "../../utils/options.data";
import UploadFileRenderer from "../../components/FileUploadRenderer";
import { canUploadImage } from "../../utils/imageValidator";
import { getFileExtension } from "../../utils/getFileExtension";
import { masterDataTypeService } from "../../services/master-data-type.service";
import MapComponent from "../../components/Maps";
import { mapsService } from "../../services/maps.service";
import useDebounce from "../../hooks/useDebounce";

const validateForm = [
  ['nama', 'telepon', 'no_hp', 'nama_penanggung_jawab', 'no_nik', 'no_kk', 'no_pbb', 'no_sertifikat', 'email', 'kota', 'kecamatan', 'kelurahan', 'jalan', 'no_rumah', 'kode_pos', 'rt', 'rw', 'status_penghuni', 'jumlah_penghuni', 'lingkungan_tertata', 'jenis_pemukiman_id', 'luas_bangunan', 'kode_tarif_id'],
  ['lokasi_bangunan', 'latitude', 'longitude'],
  ['novak_blok', 'nomen_terdekat', 'sumber_lain', 'jaringan_pipa', 'jarak_bangunan_dengan_pipa', 'ukuran_pipa_id', 'diameter_pipa_id', 'jenis_jalan_id', 'perlu_crossing_jalan', 'lebar_jalan', 'perlu_crossing_air', 'panjang_casing_pipa', 'perlu_crossing_air', 'sanitasi', 'saluran_pembuangan', 'halaman', 'golongan_konsumen_id', 'nomen_lama', 'tekanan_air', 'peruntukan_bangunan', 'perlu_bor_tembok', 'lebar_jalan', 'cc', 'pa_pc', 'blok_ez'],
  ['kamar_tidur', 'kamar_mandi', 'ruang_tamu', 'ruang_makan', 'ruang_keluarga', 'dapur', 'teras', 'garasi', 'gudang', 'jumlah_lantai'],
  ['skema_pembayaran', 'keterangan_lain', 'program_sambungan_baru_id', 'program_kategori', 'nama_program_kategori', 'object_id_bnba', 'field_survey_id_maps_bnba']
]

const addressNumberFormatter = {
  formatter: (value) => {
    const numericValue = value.replace(/\D/g, '');

    if (numericValue) {
      return numericValue.padStart(3, '0');
    }
    return '';
  },
  parser: (value) => {
    return value.replace(/\D/g, '');
  }
}

export default function PendingDocumentAnalysisDetail() {

  const queryClient = useQueryClient();

  const navigate = useNavigate()

  const { id } = useParams()
  const [form] = Form.useForm()
  const [rejectForm] = Form.useForm()
  const [acceptForm] = Form.useForm()

  const breakpoint = Grid.useBreakpoint()

  const [stepPosition, setStepPosition] = useState(0);
  const [customerSignature, setCustomerSignature] = useState('')
  const [surveyorSignature, setSurveyorSignature] = useState('')
  const [previewImage, setPrevieImage] = useState('')
  const [status, setStatus] = useState('')
  const [openChangeModal, setOpenChangedDocument] = useState(false)

  const [selectedAddress, setSelectedAddress] = useState('')
  const [searchAddress, setSearchAddress] = useState('')
  const [position, setPosition] = useState([-6.1995, 106.8118])

  const addressDebounce = useDebounce(searchAddress, 300)

  const [customerImage, setCustomerImage] = useState([])
  const [serviceLetter, setServiceLetter] = useState([])
  const [additionalLetter, setAdditionalLetter] = useState([])
  const [changedDocument, setChangedDocument] = useState([])
  const [changedDocumentType, setChangedDocumentType] = useState('')

  const { data } = useQuery({
    queryKey: ['detailSurvey', id],
    queryFn: () => surveyService.getById(id),
    enabled: !!id
  })

  const { data: jenisPemukimanMaster } = useQuery({
    queryKey: ['jenisPemukiman'],
    queryFn: () => masterDataTypeService.getByName('Jenis Pemukiman'),
  })

  const { data: kodeTarifMaster } = useQuery({
    queryKey: ['kodeTarif'],
    queryFn: () => masterDataTypeService.getByName('Kode Tarif'),
  })

  const { data: ukuranPipaMaster } = useQuery({
    queryKey: ['ukuranPipa'],
    queryFn: () => masterDataTypeService.getByName('Ukuran Pipa'),
  })

  const { data: jenisJalanMaster } = useQuery({
    queryKey: ['jenisJalan'],
    queryFn: () => masterDataTypeService.getByName('Jenis Jalan'),
  })

  const { data: diameterPipaMaster } = useQuery({
    queryKey: ['diameterPipa'],
    queryFn: () => masterDataTypeService.getByName('Diameter Pipa Dinas'),
  })

  const { data: golonganKonsumenMaster } = useQuery({
    queryKey: ['golonganKonsumen'],
    queryFn: () => masterDataTypeService.getByName('Golongan Konsumen'),
  })

  const { data: programSambunganBaru } = useQuery({
    queryKey: ['programSambunganBaru'],
    queryFn: () => masterDataTypeService.getByName('Program Sambungan Baru'),
  })

  const { data: addressResponse } = useQuery({
    queryKey: ['searchAddress', addressDebounce],
    queryFn: () => mapsService.searchAddress(addressDebounce),
    enabled: !!addressDebounce
  })

  const reverseGeocodeMutation = useMutation({
    mutationFn: () => mapsService.reverseGeocode(position[0], position[1]),
    onSuccess: (data) => {
      setSelectedAddress(data.display_name)
      form.setFieldsValue({ lokasi_bangunan: data.display_name, latitude: Number(data.lat), longitude: Number(data.lon) });
    }
  })

  const updateMutation = useMutation({
    mutationKey: ['updateSurvey'],
    mutationFn: val => surveyService.update(val),
    onSuccess: () => {
      // message.success("Data berhasil disimpan")
    },
    onError: () => {
      message.error("Terjadi kesalahan")
    }
  })

  const rejectMutation = useMutation({
    mutationKey: ['rejectMutation'],
    mutationFn: (val) => surveyService.reject({ ...val, id }),
    onSuccess: () => {
      message.success("Data berhasil ditolak")
      return navigate("/document-analysis/pending")
    }
  })

  const acceptMutation = useMutation({
    mutationKey: ['acceptMutation'],
    mutationFn: (val) => surveyService.acceptSurvey(id, val),
    onSuccess: () => {
      message.success("Survey diteruskan ke officer")
      return navigate("/document-analysis/pending")
    }
  })

  const uploadFileMutation = useMutation({
    mutationKey: ['uploadAdditional'],
    mutationFn: val => surveyService.uploadAdditionalLetter(id, val),
  })

  const uploadServiceLetterMutation = useMutation({
    mutationKey: ['uploadService'],
    mutationFn: val => surveyService.uploadServiceLetter(id, val),
  })

  const deleteFileMutation = useMutation({
    mutationKey: ['deleteFile'],
    mutationFn: val => surveyService.deleteFile(id, val),
    onSuccess: () => {
      message.success("Data berhasil dihapus")
    },
    onError: (res) => {
      console.log(res)
      message.error("Terjadi kesalahan")
    }
  })

  const changedDocumentMutation = useMutation({
    mutationFn: val => surveyService.changeDocument(id, val),
    onSuccess: () => {
      setOpenChangedDocument(false)
      message.success("Document Berhasil diubah")
      queryClient.invalidateQueries('detailSurvey')
    },
    onError: (err) => {
      console.log(err)
    }
  })

  useEffect(() => {
    if (id) {
      form.setFieldsValue(data?.data)
      setSelectedAddress(data?.data.lokasi_bangunan)
      form.setFieldValue('latitude', Number(data?.data.koordinat.latitude))
      form.setFieldValue('longitude', Number(data?.data.koordinat.longitude))
      setPosition([Number(data?.data.koordinat.latitude), Number(data?.data.koordinat.longitude)])

      if (data?.data?.serviceLetter) {
        setServiceLetter([
          {
            ...data?.data?.serviceLetter,
            name: data?.data?.serviceLetter.fileName,
            size: data?.data?.serviceLetter.fileSize,
            preview: `${API_BASE_URL}/files/${data?.data?.serviceLetter.filePath}`
          }
        ])
      }

      if (data?.data?.additionalLetter) {
        setAdditionalLetter(
          data?.data?.additionalLetter.map(e => ({
            ...e,
            name: e.fileName,
            size: e.fileSize,
            preview: `${API_BASE_URL}/files/${e.filePath}`
          }))
        )
      }

      if (data?.data?.customerImage) {
        setCustomerImage(
          data?.data?.customerImage.map(e => ({
            ...e,
            name: e.fileName,
            size: e.fileSize,
            preview: `${API_BASE_URL}/files/${e.filePath}`
          }))
        )
      }

      if (data?.data?.tanda_tangan_pelanggan) {
        setCustomerSignature(data?.data?.tanda_tangan_pelanggan)
      }

      if (data?.data?.tanda_tangan_surveyor) {
        setSurveyorSignature(data?.data?.tanda_tangan_surveyor)
      }

    }

  }, [form, data, id])

  const handleNext = () => {
    form.validateFields(validateForm[stepPosition])
      .then(() => {
        const data = form.getFieldsValue(validateForm[stepPosition])
        updateMutation.mutate({ ...data, id })
        setStepPosition(stepPosition + 1)
      })
  }

  const handleReject = val => {
    Modal.confirm({
      centered: true,
      title: "Pemberitahuan",
      content: "Yakin ingin menolak survey ?",
      onOk: () => rejectMutation.mutate(val)
    })
  }

  const handleSelectAddress = (val) => {
    const selected = addressResponse?.find(e => e.display_name == val)
    setSelectedAddress(selected.display_name)
    setPosition([Number(selected.lat), Number(selected.lon)])
    form.setFieldValue('lokasi_bangunan', selected.display_name)
    form.setFieldValue('latitude', Number(selected.lat))
    form.setFieldValue('longitude', Number(selected.lon))
  }

  const handleAccept = (val) => {

    Modal.confirm({
      centered: true,
      title: "Pemberitahuan",
      content: "Yakin ingin meneruskan survey ke officer ?",
      onOk: () => acceptMutation.mutate(val)
    })
  }

  const handleCloseChangedDocumentModal = () => {
    setChangedDocument([])
    setOpenChangedDocument(false)
  }

  const onChangeDocument = (type) => {
    setChangedDocumentType(type)
    setOpenChangedDocument(true)
  }

  const handleChangeDocument = () => changedDocumentMutation.mutate({ file: changedDocument[0], type: changedDocumentType })

  const getBase64 = file =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });

  const preprocessUpload = async (file) => {
    file.preview = await getBase64(file)
    if (!canUploadImage(file.name)) {
      message.error(`Format file tidak benar`);
      return Upload.LIST_IGNORE; // 
    }
    if (file.size > MAX_FILE_SIZE) {
      message.error(`File tidak boleh lebih dari ${MAX_FILE_SIZE / 1024 / 1024} MB`);
      return Upload.LIST_IGNORE; // Mencegah upload
    }
  }

  return (
    <>
      <Card
        title="Detail Survey Pelanggan"
        actions={[
          <>
            <Flex key={'1'} justify="end" gap={16} style={{ paddingRight: 24 }} >
              <Button
                onClick={() => setStepPosition(stepPosition - 1)}
                variant="outlined"
                color="primary"
                disabled={status.length > 0}
              >
                Kembali
              </Button>
              <RenderIf when={stepPosition == 6} >
                <Button
                  onClick={() => setStatus('reject')}
                  variant="outlined"
                  color="danger"
                  disabled={status.length > 0}
                >
                  Tolak
                </Button>
              </RenderIf>
              <Button
                onClick={stepPosition == 6 ? () => setStatus('accept') : handleNext}
                variant="solid"
                color="primary"
                disabled={status.length > 0}
              >
                {
                  stepPosition == 6
                    ? 'Terima'
                    : 'Selanjutnya'
                }
              </Button>
            </Flex>
            <RenderIf when={status == 'reject'} >
              <Divider style={{ marginTop: 14 }} />
              <div style={{ padding: '0 24px' }} >
                <Typography.Title level={5} style={{ marginTop: 20, textAlign: 'left' }} >
                  Tolak Survey
                </Typography.Title>
                <Form
                  form={rejectForm}
                  layout="vertical"
                  onFinish={handleReject}

                >
                  <Form.Item style={{ textAlign: 'left' }} label="Alasan Tolak" name={'reason'} rules={[{ required: true }]} >
                    <AutoComplete
                      options={cancelReason.map(e => ({ label: e, value: e }))}
                      filterOption
                    />
                  </Form.Item>
                </Form>
                <Flex key={'1'} justify="end" gap={12} style={{ marginTop: 28, marginBottom: 20 }} >
                  <Button
                    variant="outlined"
                    color="danger"
                    onClick={() => setStatus('')}
                  >
                    Batal
                  </Button>
                  <Button
                    variant="solid"
                    color="primary"
                    onClick={() => rejectForm.submit()}
                  >
                    Submit
                  </Button>
                </Flex>
              </div>
            </RenderIf>
            <RenderIf when={status == 'accept'} >
              <Divider style={{ marginTop: 14 }} />
              <div style={{ padding: '0 24px' }} >
                <Typography.Title level={5} style={{ marginTop: 20, textAlign: 'left' }} >
                  Terima Survey
                </Typography.Title>
                <Form
                  form={acceptForm}
                  layout="vertical"
                  onFinish={handleAccept}

                >
                  <Form.Item style={{ textAlign: 'left' }} label="Catatan Untuk Officer" name={'reason'}  >
                    <Input.TextArea rows={4} />
                  </Form.Item>
                </Form>
                <Flex key={'1'} justify="end" gap={12} style={{ marginTop: 28, marginBottom: 20 }} >
                  <Button
                    variant="outlined"
                    color="danger"
                    onClick={() => setStatus('')}
                  >
                    Batal
                  </Button>
                  <Button
                    variant="solid"
                    color="primary"
                    onClick={() => acceptForm.submit()}
                  >
                    Submit
                  </Button>
                </Flex>
              </div>
            </RenderIf>
          </>
        ]}
      >
        <Flex gap={40} >
          <Form
            layout="vertical"
            style={{ flex: 1 }}
            form={form}
          >
            <Form.Item name={'id'} hidden >
              <Input />
            </Form.Item>
            <RenderIf when={stepPosition === 0} >
              <Row gutter={[20]} >
                <Col sm={12} xs={24} >
                  <Form.Item
                    label="Nama"
                    name={'nama'}
                    rules={[{ required: true }]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col sm={12} xs={24} >
                  <Form.Item
                    label="Penanggung Jawab"
                    name={'nama_penanggung_jawab'}
                    rules={[{ required: true }]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col sm={12} xs={24} >
                  <Form.Item
                    name={'no_nik'}
                    label={'No KTP'}
                    rules={[{ required: true }]}
                  >
                    <InputNumber style={{ width: '100%' }} />
                  </Form.Item>
                </Col>
                <Col sm={12} xs={24} >
                  <Form.Item
                    name={'no_kk'}
                    label={'No KK'}
                    rules={[{ required: true }]}
                  >
                    <InputNumber style={{ width: '100%' }} />
                  </Form.Item>
                </Col>
                <Col sm={12} xs={24} >
                  <Form.Item
                    name={'no_pbb'}
                    label={'No PBB'}
                    rules={[{ required: true }]}
                  >
                    <InputNumber style={{ width: '100%' }} />
                  </Form.Item>
                </Col>
                <Col sm={12} xs={24} >
                  <Form.Item
                    name={'no_sertifikat'}
                    label={'No Sertifikat'}
                    rules={[{ required: true }]}
                  >
                    <InputNumber style={{ width: '100%' }} />
                  </Form.Item>
                </Col>
                <Col span={6} >
                  <Form.Item
                    label="No Telepon"
                    name={'telepon'}
                    rules={[{ required: true }]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={6} >
                  <Form.Item
                    label="No HP"
                    name={'no_hp'}
                    rules={[{ required: true }]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={12} >
                  <Form.Item
                    label="Email"
                    name={'email'}
                    rules={[{ required: true }]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={[20]} >
                <Col span={12} >
                  <Form.Item
                    label="Kota"
                    name={'kota'}
                    rules={[{ required: true }]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={12} >
                  <Form.Item
                    label="Kecamatan"
                    name={'kecamatan'}
                    rules={[{ required: true }]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={[20]} >
                <Col span={12} >
                  <Form.Item
                    label="Kelurahan"
                    name={'kelurahan'}
                    rules={[{ required: true }]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={12} >
                  <Form.Item
                    label="Jalan"
                    name={'jalan'}
                    rules={[{ required: true }]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={[20]} >
                <Col span={6} >
                  <Form.Item
                    label="No Rumah"
                    name={'no_rumah'}
                    rules={[{ required: true }]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={6} >
                  <Form.Item
                    label="Kode Pos"
                    name={'kode_pos'}
                    rules={[{ required: true }]}
                  >
                    <InputNumber
                      style={{ width: '100%' }}
                    />
                  </Form.Item>
                </Col>
                <Col span={6} >
                  <Form.Item
                    label="RT"
                    name={'rt'}
                    rules={[{ required: true }]}
                  >
                    <InputNumber
                      style={{ width: '100%' }}
                      {...addressNumberFormatter}
                    />
                  </Form.Item>
                </Col>
                <Col span={6} >
                  <Form.Item
                    label="RW"
                    name={'rw'}
                    rules={[{ required: true }]}
                  >
                    <InputNumber
                      style={{ width: '100%' }}
                      {...addressNumberFormatter}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={[20]} >
                <Col span={12} >
                  <Form.Item
                    label="Status Penghuni"
                    name={'status_penghuni'}
                    rules={[{ required: true }]}
                  >
                    <Select
                      options={['Pemilik', 'Saudara/Kerabat', 'Penyewa'].map(e => ({ label: e, value: e }))}
                      showSearch
                      optionFilterProp="label"
                    />
                  </Form.Item>
                </Col>
                <Col span={12} >
                  <Form.Item
                    label="Jumlah Penghuni"
                    name={'jumlah_penghuni'}
                    rules={[{ required: true }]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={12} >
                  <Form.Item
                    label="Lingkungan Tertata"
                    name={'lingkungan_tertata'}
                    rules={[{ required: true }]}
                  >
                    <Radio.Group>
                      <Radio style={{ marginRight: 120 }} value={'Ya'} >Ya</Radio>
                      <Radio value={'Tidak'} >Tidak</Radio>
                    </Radio.Group>
                  </Form.Item>
                </Col>
                <Col span={12} >
                  <Form.Item
                    label="Jenis Pemukiman"
                    name={'jenis_pemukiman_id'}
                    rules={[{ required: true }]}
                  >
                    <Select
                      options={jenisPemukimanMaster?.data?.items.map(e => ({ label: e.name, value: e.id }))}
                      optionFilterProp="label"
                      showSearch
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Form.Item
                label="Kode Tarif"
                name={'kode_tarif_id'}
                rules={[{ required: true }]}
              >
                <Select
                  options={kodeTarifMaster?.data?.items.map(e => ({ label: e.name, value: e.id }))}
                  showSearch
                  optionFilterProp="label"
                />
              </Form.Item>
              <Form.Item
                label="Luas Bangunan"
                name={'luas_bangunan'}
                rules={[{ required: true }]}
              >
                <Input suffix="m2" />
              </Form.Item>
            </RenderIf>
            <RenderIf when={stepPosition === 1} >
              <Form.Item
                name={'latitude'}
                hidden
              >
                <Input />
              </Form.Item>
              <Form.Item
                name={'longitude'}
                hidden
              >
                <Input />
              </Form.Item>
              <Row gutter={[20]} >
                <Col span={12} >
                  <Form.Item label="Latitude" >
                    <Input style={{ backgroundColor: pallete.grey[200] }} readOnly value={data?.data?.ab?.KOORDINAT.LATITUDE} />
                  </Form.Item>
                </Col>
                <Col span={12} >
                  <Form.Item label="Longitude" >
                    <Input style={{ backgroundColor: pallete.grey[200] }} readOnly value={data?.data?.ab?.KOORDINAT.LONGITUDE} />
                  </Form.Item>
                </Col>
              </Row>
              <Form.Item
                label="Titik Lokasi Bangunan"
                name={'lokasi_bangunan'}
                rules={[{ required: true }]}
              >
                <AutoComplete
                  value={selectedAddress}
                  onSearch={setSearchAddress}
                  onSelect={handleSelectAddress}
                  options={addressResponse?.map(e => (
                    {
                      value: e.display_name,
                      label: (
                        <Space direction="vertical" size={3} >
                          <Typography.Text style={{ fontSize: 12, fontWeight: 600, margin: 0 }} >
                            {e.name}
                          </Typography.Text>
                          <Typography.Text style={{ fontSize: 12, color: pallete.grey[700], margin: 0 }} >
                            {e.display_name}
                          </Typography.Text>
                        </Space>
                      )
                    }
                  ))}
                />
              </Form.Item>
              <Card styles={{ body: { padding: 0 } }} >
                <MapComponent
                  position={position}
                  setPosition={setPosition}
                  reverseGeocodeMutation={reverseGeocodeMutation.mutate}
                />
              </Card>
            </RenderIf>
            <RenderIf when={stepPosition === 2} >
              <Row gutter={[20]} >
                <Col sm={6} xs={12} >
                  <Form.Item
                    label="Regional"
                  // name={'pa_pc'}
                  >
                    <Input
                      value={data?.data.ab.REGIONAL}
                      readOnly
                      style={{ backgroundColor: pallete.grey[200] }}
                    />
                  </Form.Item>
                </Col>
                <Col sm={6} xs={12} >
                  <Form.Item
                    label="AB"
                  >
                    <Input
                      value={data?.data.ab.NAMA_AB}
                      readOnly
                      style={{ backgroundColor: pallete.grey[200] }}
                    />
                  </Form.Item>
                </Col>
                <Col sm={6} xs={12} >
                  <Form.Item
                    label="PA/PC"
                    name={'pa_pc'}
                  >
                    <Input
                    />
                  </Form.Item>
                </Col>
                <Col sm={6} xs={12} >
                  <Form.Item
                    label="BlOK/EZ"
                    name={'blok_ez'}
                  >
                    <Input
                    />
                  </Form.Item>
                </Col>
                <Col span={6} >
                  <Form.Item
                    label="NOVAK/BLOK"
                    name={'novak_blok'}
                    rules={[{ required: true }]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col sm={6} >
                  <Form.Item
                    label="Nomen Terdekat"
                    name={'nomen_terdekat'}
                    rules={[{ required: true }]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col sm={12} xs={24} >
                  <Form.Item
                    label="CC"
                    name={'cc'}
                    rules={[{ required: true }]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={24} >
                  <Form.Item
                    label="Sumber air lain yang digunakan pelanggan"
                    name={'sumber_lain'}
                    rules={[{ required: true }]}
                  >
                    <Select
                      options={sumberAir.map(e => ({ label: e, value: e }))}
                      showSearch
                    />
                  </Form.Item>
                </Col>
                <Col span={12} >
                  <Form.Item
                    label="Jaringan Pipa"
                    name={'jaringan_pipa'}
                    rules={[{ required: true }]}
                  >
                    <Radio.Group>
                      <Radio style={{ marginRight: 60 }} value={'Ada'} >Ada Jaringan</Radio>
                      <Radio value={'Tidak Ada'} >Tidak Ada Jaringan</Radio>
                    </Radio.Group>
                  </Form.Item>
                </Col>
                <Col span={12} >
                  <Form.Item
                    label="Jarak bangunan dengan pipa existing PAM JAYA (m)"
                    name={'jarak_bangunan_dengan_pipa'}
                    rules={[{ required: true }]}
                  >
                    <InputNumber style={{ width: '100%' }} suffix="m" />
                  </Form.Item>
                </Col>
                <Col span={12} >
                  <Form.Item
                    label="Ukuran Pipa Input"
                    name={'ukuran_pipa_id'}
                    rules={[{ required: true }]}
                  >
                    <Select
                      options={ukuranPipaMaster?.data?.items.map(e => ({ label: e.name, value: e.id }))}
                      showSearch
                      optionFilterProp="label"
                    />
                  </Form.Item>
                </Col>
                <Col span={12} >
                  <Form.Item
                    label="Diameter Pipa Dinas yang akan dipasang "
                    name={'diameter_pipa_id'}
                    rules={[{ required: true }]}
                  >
                    <Select
                      options={diameterPipaMaster?.data?.items.map(e => ({ label: e.name, value: e.id }))}
                      showSearch
                      optionFilterProp="label"
                    />
                  </Form.Item>
                </Col>
                <Col span={24} >
                  <Form.Item
                    label="Jenis jalan/galian"
                    name={'jenis_jalan_id'}
                    rules={[{ required: true }]}
                  >
                    <Select
                      options={jenisJalanMaster?.data?.items?.map(e => ({ label: e.name, value: e.id }))}
                      optionFilterProp="label"
                      showSearch
                    />
                  </Form.Item>
                </Col>
                <Col span={12} >
                  <Form.Item
                    label="Perlu crosing jalan"
                    name={'perlu_crossing_jalan'}
                    rules={[{ required: true }]}
                  >
                    <Radio.Group>
                      <Radio style={{ marginRight: 120 }} value={'Y'} >Ya</Radio>
                      <Radio value={'N'} >Tidak</Radio>
                    </Radio.Group>
                  </Form.Item>
                </Col>
                <Col span={12} >
                  <Form.Item
                    label="Lebar Jalan"
                    name={'lebar_jalan'}
                    rules={[{ required: true }]}
                  >
                    <InputNumber style={{ width: '100%' }} suffix="m" />
                  </Form.Item>
                </Col>
                <Col span={12} >
                  <Form.Item
                    label="Perlu crosing saluran air"
                    name={'perlu_crossing_air'}
                    rules={[{ required: true }]}
                  >
                    <Radio.Group>
                      <Radio style={{ marginRight: 120 }} value={'Y'} >Ya</Radio>
                      <Radio value={'N'} >Tidak</Radio>
                    </Radio.Group>
                  </Form.Item>
                </Col>
                <Col span={12} >
                  <Form.Item
                    label="Panjang casing pipa"
                    name={'panjang_casing_pipa'}
                    rules={[{ required: true }]}
                  >
                    <InputNumber style={{ width: '100%' }} suffix="m" />
                  </Form.Item>
                </Col>
                <Col span={12} >
                  <Form.Item
                    label="Halaman"
                    name={'halaman'}
                    rules={[{ required: true }]}
                  >
                    <Radio.Group>
                      <Radio style={{ marginRight: 120 }} value={'Y'} >Ya</Radio>
                      <Radio value={'N'} >Tidak</Radio>
                    </Radio.Group>
                  </Form.Item>
                </Col>
                <Col span={6} >
                  <Form.Item
                    label="Sanitasi"
                    name={'sanitasi'}
                    rules={[{ required: true }]}
                  >
                    <Radio.Group>
                      <Radio style={{ marginRight: 120 }} value={'Y'} >Ya</Radio>
                      <Radio value={'N'} >Tidak</Radio>
                    </Radio.Group>
                  </Form.Item>
                </Col>
                <Col span={6} >
                  <Form.Item
                    label="Saluran Pembuangan"
                    name={'saluran_pembuangan'}
                    rules={[{ required: true }]}
                  >
                    <Radio.Group>
                      <Radio style={{ marginRight: 120 }} value={'Y'} >Ya</Radio>
                      <Radio value={'N'} >Tidak</Radio>
                    </Radio.Group>
                  </Form.Item>
                </Col>
                <Col span={24} >
                  <Form.Item
                    label="Golongan Konsumen"
                    name={'golongan_konsumen_id'}
                    rules={[{ required: true }]}
                  >
                    <Select
                      options={golonganKonsumenMaster?.data?.items?.map(e => ({ label: e.name, value: e.id }))}
                      optionFilterProp="label"
                      showSearch
                    />
                  </Form.Item>
                </Col>
                <Col sm={12} xs={12} >
                  <Form.Item
                    label="Nomen Lama"
                    name={'nomen_lama'}
                    rules={[{ required: true }]}
                  >
                    <InputNumber style={{ width: '100%' }} />
                  </Form.Item>
                </Col>
                <Col sm={12} xs={12} >
                  <Form.Item
                    label="Tekanan Air"
                    name={'tekanan_air'}
                    rules={[{ required: true }]}
                  >
                    <InputNumber style={{ width: '100%' }} suffix="m" />
                  </Form.Item>
                </Col>
                <Col sm={12} xs={12} >
                  <Form.Item
                    label="Peruntukan Bangunan"
                    name={'peruntukan_bangunan'}
                    rules={[{ required: true }]}
                  >
                    <Radio.Group>
                      <Radio style={{ marginRight: 120 }} value={'D'} >Domestic</Radio>
                      <Radio value={'Tidak'} >Non Domestic</Radio>
                    </Radio.Group>
                  </Form.Item>
                </Col>
                <Col sm={12} xs={12} >
                  <Form.Item
                    label="Perlu Bor Tembok"
                    name={'perlu_bor_tembok'}
                    rules={[{ required: true }]}
                  >
                    <Radio.Group>
                      <Radio style={{ marginRight: 120 }} value={'Y'} >Ya</Radio>
                      <Radio value={'N'} >Tidak</Radio>
                    </Radio.Group>
                  </Form.Item>
                </Col>
              </Row>
            </RenderIf>
            <RenderIf when={stepPosition == 3} >
              <Row gutter={[20]} >
                <Col span={12} >
                  <Form.Item
                    label="Kamar Tidur"
                    name={'kamar_tidur'}
                    rules={[{ required: true }]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={12} >
                  <Form.Item
                    label="Kamar Mandi"
                    name={'kamar_mandi'}
                    rules={[{ required: true }]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={12} >
                  <Form.Item
                    label="Ruang Tamu"
                    name={'ruang_tamu'}
                    rules={[{ required: true }]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={12} >
                  <Form.Item
                    label="Ruang Makan"
                    name={'ruang_makan'}
                    rules={[{ required: true }]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={12} >
                  <Form.Item
                    label="Ruang Keluarga"
                    name={'ruang_keluarga'}
                    rules={[{ required: true }]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={12} >
                  <Form.Item
                    label="Dapur"
                    name={'dapur'}
                    rules={[{ required: true }]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={12} >
                  <Form.Item
                    label="Teras"
                    name={'teras'}
                    rules={[{ required: true }]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={12} >
                  <Form.Item
                    label="Garasi"
                    name={'garasi'}
                    rules={[{ required: true }]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={12} >
                  <Form.Item
                    label="Gudang/Paviliun"
                    name={'gudang'}
                    rules={[{ required: true }]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={12} >
                  <Form.Item
                    label="Jumlah Lantai"
                    name={'jumlah_lantai'}
                    rules={[{ required: true }]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
              </Row>
            </RenderIf>
            <RenderIf when={stepPosition == 4} >
              <div style={{ marginBottom: 20 }} >
                <Upload
                  style={{ width: '100%', display: 'block' }}
                  rootClassName="survey-upload"
                  disabled={serviceLetter.length != 0}
                  beforeUpload={(file) => {
                    if (file.size > MAX_FILE_SIZE) {
                      message.error(`File tidak boleh lebih dari ${MAX_FILE_SIZE / 1024 / 1024} MB`);
                      return Upload.LIST_IGNORE; // Mencegah upload
                    }
                    uploadServiceLetterMutation.mutateAsync({ serviceLetter: file })
                      .then(res => {
                        setServiceLetter([
                          {
                            ...res.data,
                            name: res?.data?.fileName,
                            size: res?.data?.fileSize,
                          }
                        ])
                        return false
                      })
                      .catch(err => console.log(err))
                  }}
                  fileList={serviceLetter}
                  onRemove={(file) => {
                    deleteFileMutation.mutateAsync(file.id)
                      .then(() => setServiceLetter([]))
                      .catch(err => console.log(err))
                  }}
                  itemRender={(_, file, filelist, action) => (
                    <Card
                      style={{ marginTop: 20 }}
                      styles={{
                        body: {
                          padding: '10px 14px'
                        }
                      }}
                    >
                      <Flex align="center" gap={10} >
                        <Space direction="vertical" size={2} style={{ marginRight: 'auto' }} >
                          <Typography.Text style={{ fontWeight: 500, marginBottom: 0 }} >
                            {file.name}
                          </Typography.Text>
                        </Space>
                        <Button
                          icon={<Icon icon='solar:eye-bold-duotone' />}
                          color="primary"
                          variant="outlined"
                          size="small"
                          onClick={() => setPrevieImage(file.preview)}
                        />
                        <Popconfirm
                          placement="left"
                          title="Pemberitahuan"
                          description="Yakin ingin hapus file ?"
                          okButtonProps={{
                            danger: true,
                            loading: deleteFileMutation.isPending
                          }}
                          okText="Hapus"
                          onConfirm={action.remove}
                        >
                          <Button
                            icon={<Icon icon='solar:trash-bin-minimalistic-bold-duotone' />}
                            danger
                            size="small"
                          />
                        </Popconfirm>
                      </Flex>
                    </Card>
                  )}
                >
                  <Flex justify="space-between" >
                    <div style={{ flex: 1 }} >
                      <Typography.Text style={{ display: 'block' }} >
                        Surat Pelayanan Sementara
                      </Typography.Text>
                      <Typography.Text type="secondary" >
                        File jpeg, png, jpg, pdf, Max. file size: 2 MB
                      </Typography.Text>
                    </div>
                    <Button
                      icon={<Icon icon="solar:upload-minimalistic-bold-duotone" width="18" height="18" />}
                      disabled={serviceLetter.length > 0}
                    >
                      Upload
                    </Button>
                  </Flex>
                </Upload>
              </div>
              <div style={{ marginBottom: 20 }} >
                <Upload
                  style={{ width: '100%', display: 'block' }}
                  rootClassName="survey-upload"
                  disabled={additionalLetter.length == 5}
                  multiple
                  beforeUpload={(file) => {
                    if (file.size > MAX_FILE_SIZE) {
                      message.error(`File tidak boleh lebih dari ${MAX_FILE_SIZE / 1024 / 1024} MB`);
                      return Upload.LIST_IGNORE; // Mencegah upload
                    }
                    uploadFileMutation.mutateAsync({ additionalLetter: file })
                      .then(res => {
                        const uploadedFiles = Array.isArray(res.data) ? res.data : [res.data];

                        const newFiles = uploadedFiles.map(e => ({
                          ...e,
                          name: e.fileName,
                          size: e.fileSize,
                        }));

                        setAdditionalLetter(prevAdditionalLetter => [
                          ...prevAdditionalLetter,
                          ...newFiles,
                        ]);
                      })
                      .catch(err => {
                        console.error("Error uploading file:", err);
                      });

                    return false;
                  }}
                  fileList={additionalLetter}
                  onRemove={(file) => {
                    deleteFileMutation.mutateAsync(file.id).then(() => {
                      const index = additionalLetter.indexOf(file);
                      const newFileList = additionalLetter.slice();
                      newFileList.splice(index, 1);
                      setAdditionalLetter(newFileList);
                    })
                  }}
                  itemRender={(_, file, filelist, action) => (
                    <Card
                      style={{ marginTop: 20 }}
                      styles={{
                        body: {
                          padding: '10px 14px'
                        }
                      }}
                    >
                      <Flex align="center" gap={10} >
                        <Space direction="vertical" size={2} style={{ marginRight: 'auto' }} >
                          <Typography.Text style={{ fontWeight: 500, marginBottom: 0 }} >
                            {file.name}
                          </Typography.Text>
                        </Space>
                        <Button
                          icon={<Icon icon='solar:eye-bold-duotone' />}
                          color="primary"
                          variant="outlined"
                          size="small"
                          onClick={() => setPrevieImage(file.preview)}
                        />
                        <Popconfirm
                          placement="left"
                          title="Pemberitahuan"
                          description="Yakin ingin hapus file ?"
                          okButtonProps={{
                            danger: true,
                            loading: deleteFileMutation.isPending
                          }}
                          okText="Hapus"
                          onConfirm={action.remove}
                        >
                          <Button
                            icon={<Icon icon='solar:trash-bin-minimalistic-bold-duotone' />}
                            danger
                            size="small"
                          />
                        </Popconfirm>
                      </Flex>
                    </Card>
                  )}
                >
                  <Flex justify="space-between" >
                    <div style={{ flex: 1 }} >
                      <Typography.Text style={{ display: 'block' }} >
                        Dokumen Pendukung
                      </Typography.Text>
                      <Typography.Text type="secondary" >
                        File jpeg, png, jpg, pdf, Max. file size: 2 MB
                      </Typography.Text>
                    </div>
                    <Button
                      icon={<Icon icon="solar:upload-minimalistic-bold-duotone" width="18" height="18" />}
                      disabled={additionalLetter.length == 5}
                    >
                      Upload
                    </Button>
                  </Flex>
                </Upload>
              </div>
              <Form.Item
                label="Program Sambungan Baru"
                name={'program_sambungan_baru_id'}
                rules={[{ required: true }]}
              >
                <Select
                  options={programSambunganBaru?.data?.items?.map(e => ({ label: e.name, value: e.id }))}
                />
              </Form.Item>
              <Form.Item
                label="Program Kategori"
                name={'program_kategori'}
                rules={[{ required: true }]}
              >
                <Select
                  options={['Adhoc', 'Infill'].map(e => ({ label: e, value: e }))}
                />
              </Form.Item>
              <Form.Item
                label="Nama Program Kategori"
                name={'nama_program_kategori'}
                rules={[{ required: true }]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="Object ID BNBA"
                name={'object_id_bnba'}
                rules={[{ required: true }]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="Field Survey ID Field Maps BNBA"
                name={'field_survey_id_maps_bnba'}
                rules={[{ required: true }]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="Skema Pembayaran"
                name={'skema_pembayaran'}
                rules={[{ required: true }]}
              >
                <Select
                  options={skemaPembayaran.map(e => ({ label: e, value: e }))}
                />
              </Form.Item>
              <Form.Item
                label="Informasi Tambahan"
                name={'keterangan_lain'}
              >
                <Input.TextArea rows={5} />
              </Form.Item>
              <Descriptions
                column={1}
                bordered
                style={{ marginTop: 24 }}
                styles={{ label: { width: 110 }, content: { width: '100%' } }}
                size="small"
                items={[
                  {
                    label: 'KTP',
                    children: (
                      <Flex gap={8} align="center" >
                        <Typography.Text style={{ marginRight: 'auto' }}>{data?.data?.acceptance?.registration?.ktp}</Typography.Text>
                        <Flex gap={8} vertical={!breakpoint.lg} >
                          <Button
                            icon={<Icon icon="solar:refresh-linear" style={{ marginBottom: -1 }} width="18" height="18" />}
                            size="small"
                            variant="filled"
                            color="orange"
                            onClick={() => onChangeDocument('ktp')}
                          >
                            Ganti
                          </Button>
                          <Button
                            icon={<Icon icon="solar:download-square-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />}
                            variant="filled"
                            color="primary"
                            size="small"
                            style={{ fontSize: 12 }}
                          >
                            <Link to={`${API_BASE_URL}/files/registration/${data?.data?.acceptance?.registration?.kk}`} >
                              Unduh
                            </Link>
                          </Button>
                          <Button
                            variant="filled"
                            color="primary"
                            size="small"
                            style={{ fontSize: 12 }}
                            icon={<Icon icon="solar:eye-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />}
                            onClick={() => setPrevieImage(`${API_BASE_URL}/files/registration/${data?.data?.acceptance?.registration?.ktp}`)}
                          >
                            Lihat
                          </Button>
                          <Button
                            variant="filled"
                            color="primary"
                            size="small"
                            style={{ fontSize: 12 }}
                            icon={<Icon icon="solar:copy-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />}
                            onClick={() => {
                              navigator.clipboard.writeText(`${API_BASE_URL}/files/registration/${data?.data?.acceptance?.registration?.ktp}`)
                              message.success('Link berhasil disalin')
                            }}
                          >
                            Salin Link
                          </Button>
                        </Flex>

                      </Flex>
                    )
                  },
                  {
                    label: 'KK',
                    children: (
                      <Flex gap={8} align="center" >
                        <Typography.Text style={{ marginRight: 'auto' }}>{data?.data?.acceptance?.registration?.kk}</Typography.Text>
                        <Flex gap={8} vertical={!breakpoint.lg} >
                          <Button
                            icon={<Icon icon="solar:refresh-linear" style={{ marginBottom: -1 }} width="18" height="18" />}
                            size="small"
                            variant="filled"
                            color="orange"
                            onClick={() => onChangeDocument('kk')}
                          >
                            Ganti
                          </Button>
                          <Button
                            icon={<Icon icon="solar:download-square-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />}
                            variant="filled"
                            color="primary"
                            size="small"
                            style={{ fontSize: 12 }}
                          >
                            Unduh
                          </Button>
                          <Button
                            variant="filled"
                            color="primary"
                            size="small"
                            style={{ fontSize: 12 }}
                            icon={<Icon icon="solar:eye-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />}
                            onClick={() => setPrevieImage(`${API_BASE_URL}/files/registration/${data?.data?.acceptance?.registration?.kk}`)}
                          >
                            Lihat
                          </Button>
                          <Button
                            variant="filled"
                            color="primary"
                            size="small"
                            style={{ fontSize: 12 }}
                            icon={<Icon icon="solar:copy-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />}
                            onClick={() => {
                              navigator.clipboard.writeText(`${API_BASE_URL}/files/registration/${data?.data?.acceptance?.registration?.kk}`)
                              message.success('Link berhasil disalin')
                            }}
                          >
                            Salin Link
                          </Button>
                        </Flex>
                      </Flex>
                    )
                  },
                  {
                    label: 'PBB',
                    children: (
                      <Flex gap={8} align="center" >
                        <Typography.Text style={{ marginRight: 'auto' }}>{data?.data?.acceptance?.registration?.pbb ?? '-'}</Typography.Text>
                        <RenderIf when={data?.data?.acceptance?.registration?.pbb} >
                          <Flex gap={8} vertical={!breakpoint.lg} >
                            <Button
                              icon={<Icon icon="solar:refresh-linear" style={{ marginBottom: -1 }} width="18" height="18" />}
                              size="small"
                              variant="filled"
                              color="orange"
                              onClick={() => onChangeDocument('pbb')}
                            >
                              Ganti
                            </Button>
                            <Button
                              icon={<Icon icon="solar:download-square-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />}
                              variant="filled"
                              color="primary"
                              size="small"
                              style={{ fontSize: 12 }}
                            >
                              <Link to={data?.data?.acceptance?.registration?.pbb && `${API_BASE_URL}/files/registration/${data?.data?.acceptance?.registration?.pbb}`} >
                                Unduh
                              </Link>
                            </Button>
                            <Button
                              variant="filled"
                              color="primary"
                              size="small"
                              style={{ fontSize: 12 }}
                              icon={<Icon icon="solar:eye-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />}
                              onClick={() => setPrevieImage(`${API_BASE_URL}/files/registration/${data?.data?.acceptance?.registration?.pbb}`)}
                            >
                              Lihat
                            </Button>
                            <Button
                              variant="filled"
                              color="primary"
                              size="small"
                              style={{ fontSize: 12 }}
                              icon={<Icon icon="solar:copy-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />}
                              onClick={() => {
                                navigator.clipboard.writeText(`${API_BASE_URL}/files/registration/${data?.data?.acceptance?.registration?.pbb}`)
                                message.success('Link berhasil disalin')
                              }}
                            >
                              Salin Link
                            </Button>
                          </Flex>
                        </RenderIf>
                      </Flex>
                    )
                  },
                  {
                    label: 'Bangunan',
                    children: (
                      <Flex gap={8} align="center" >
                        <Typography.Text style={{ marginRight: 'auto' }}>{data?.data?.acceptance?.registration?.bangunan}</Typography.Text>
                        <Flex gap={8} vertical={!breakpoint.lg} >
                          <Button
                            icon={<Icon icon="solar:refresh-linear" style={{ marginBottom: -1 }} width="18" height="18" />}
                            size="small"
                            variant="filled"
                            color="orange"
                            onClick={() => onChangeDocument('bangunan')}
                          >
                            Ganti
                          </Button>
                          <Button
                            icon={<Icon icon="solar:download-square-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />}
                            variant="filled"
                            color="primary"
                            size="small"
                            style={{ fontSize: 12 }}
                          >
                            <Link to={`${API_BASE_URL}/files/registration/${data?.data?.acceptance?.registration?.bangunan}`} >
                              Unduh
                            </Link>
                          </Button>
                          <Button
                            variant="filled"
                            color="primary"
                            size="small"
                            style={{ fontSize: 12 }}
                            icon={<Icon icon="solar:eye-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />}
                            onClick={() => setPrevieImage(`${API_BASE_URL}/files/registration/${data?.data?.acceptance?.registration?.bangunan}`)}
                          >
                            Lihat
                          </Button>
                          <Button
                            variant="filled"
                            color="primary"
                            size="small"
                            style={{ fontSize: 12 }}
                            icon={<Icon icon="solar:copy-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />}
                            onClick={() => {
                              navigator.clipboard.writeText(`${API_BASE_URL}/files/registration/${data?.data?.acceptance?.registration?.bangunan}`)
                              message.success('Link berhasil disalin')
                            }}
                          >
                            Salin Link
                          </Button>
                        </Flex>
                      </Flex>
                    )
                  },
                ]}
              />
            </RenderIf>
            <RenderIf when={stepPosition == 5} >
              <Row style={{ height: '100%' }} >
                <Col span={12} style={{ display: 'flex', }} >
                  <Flex align="center" gap={20} vertical style={{ margin: 'auto' }} >
                    <Card
                      cover={<img src={customerSignature} style={{ objectFit: 'cover' }} />}
                      style={{ height: 200 }}
                    />
                    <Flex vertical style={{ textAlign: 'center' }} >
                      <Typography>
                        {data?.data?.nama}
                      </Typography>
                      <Typography.Text style={{ color: pallete.primary.main }} >
                        Pelanggan
                      </Typography.Text>
                    </Flex>
                  </Flex>
                </Col>
                <Col span={12} style={{ display: 'flex' }} >
                  <Flex align="center" gap={20} vertical style={{ margin: 'auto' }} >
                    <Card
                      cover={<img src={surveyorSignature} style={{ objectFit: 'cover' }} />}
                      style={{ height: 200 }}
                    />
                    <Flex vertical style={{ textAlign: 'center' }} >
                      <Typography>
                        {data?.data?.acceptance?.surveyor?.name}
                      </Typography>
                      <Typography.Text style={{ color: pallete.primary.main }} >
                        Surveyor
                      </Typography.Text>
                    </Flex>
                  </Flex>
                </Col>
              </Row>
            </RenderIf>
            <RenderIf when={stepPosition == 6} >
              <div style={{ marginBottom: 20 }} >
                <Upload
                  style={{ width: '100%', display: 'block' }}
                  rootClassName="survey-upload"
                  // disabled={customerImage.length != 0}
                  disabled={true}
                  // beforeUpload={(file) => {
                  //   if (file.size > MAX_FILE_SIZE) {
                  //     message.error(`File tidak boleh lebih dari ${MAX_FILE_SIZE / 1024 / 1024} MB`);
                  //     return Upload.LIST_IGNORE; // Mencegah upload
                  //   }
                  //   uploadCustomerImageMutation.mutateAsync({ image: file })
                  //   .then(res => {
                  //     setCustomerImage([
                  //       {
                  //         ...res.data,
                  //         name: res?.data?.fileName,
                  //         size: res?.data?.fileSize,
                  //         preview: `${API_BASE_URL}/files/`+res?.data.filePath
                  //       }
                  //     ])
                  //     return false
                  //   })
                  //   .catch(err => console.log(err))
                  // }}
                  fileList={customerImage}
                  onRemove={(file) => {
                    deleteFileMutation.mutateAsync(file.id)
                      .then(() => setCustomerImage([]))
                      .catch(err => console.log(err))
                  }}
                  itemRender={(_, file, filelist, action) => (
                    <UploadFileRenderer
                      file={file}
                      action={action}
                      activeDelete={false}
                      deleteLoading={deleteFileMutation.isPending}
                      onPreview={() => setPrevieImage(file.preview)}
                    />
                  )}
                >
                  <Flex justify="space-between" >
                    <div style={{ flex: 1 }} >
                      <Typography.Text style={{ display: 'block' }} >
                        Foto Kustomer
                      </Typography.Text>
                      <Typography.Text type="secondary" >
                        File jpeg, png, jpg, Max. file size: 2 MB
                      </Typography.Text>
                    </div>
                    <Button
                      icon={<Icon icon="solar:upload-minimalistic-bold-duotone" width="18" height="18" />}
                      disabled={serviceLetter.length != 0}
                    >
                      Upload
                    </Button>
                  </Flex>
                </Upload>
              </div>
            </RenderIf>
          </Form>
          <div style={{ width: 200, borderLeft: '.5px solid ' + pallete.grey[400], paddingLeft: 20 }} >
            <Steps
              current={stepPosition}
              onChange={(val) => {
                if (val > stepPosition) handleNext()
              }}

              items={[
                {
                  title: <Typography.Text>Pelanggan</Typography.Text>,
                },
                {
                  title: <Typography.Text>Titik Koordinat</Typography.Text>,
                },
                {
                  title: <Typography.Text>Lokasi</Typography.Text>,
                },
                {
                  title: <Typography.Text>Bangunan</Typography.Text>,
                },
                {
                  title: <Typography.Text >Dokumen & Informasi Tambahan</Typography.Text>,
                },
                {
                  title: <Typography.Text>Persetujuan</Typography.Text>,
                },
                {
                  title: <Typography.Text>Foto Pelanggan</Typography.Text>,
                }
              ]}
              direction="vertical"
              style={{ height: 420 }}
            />
          </div>
        </Flex>
      </Card>
      <Modal
        open={previewImage.length > 0}
        centered
        title="Gambar"
        onCancel={() => setPrevieImage('')}
      >
        <embed style={{ width: '100%', height: getFileExtension(previewImage) == 'pdf' && '500px' }} src={previewImage} />
      </Modal>
      <Modal
        open={openChangeModal}
        onCancel={handleCloseChangedDocumentModal}
        title="Ganti Berkas"
        centered
        okText="Submit"
        okButtonProps={{
          disabled: !changedDocument.length,
          onClick: handleChangeDocument
        }}
        styles={{
          body: {
            paddingTop: 20,
            paddingBottom: 20,
          }
        }}
      >
        <Upload
          style={{ width: '100%', display: 'block' }}
          rootClassName="survey-upload"
          beforeUpload={async (file) => {
            await preprocessUpload(file)
            setChangedDocument([file])
            return false
          }}
          fileList={changedDocument}
          onRemove={() => {
            setChangedDocument([])
          }}
          itemRender={(_, file, filelist, action) => (
            <UploadFileRenderer
              file={file}
              action={action}
              onPreview={() => setPrevieImage(file.preview)}
            />
          )}
        >
          <Flex justify="space-between" >
            <div style={{ flex: 1 }} >
              <Typography.Text style={{ display: 'block' }} >
                <Typography.Text style={{ color: 'red', marginRight: 6 }} >
                  *
                </Typography.Text>
                Upload Dokumen Pengganti
              </Typography.Text>
              <Typography.Text type="secondary" style={{ paddingLeft: 11 }} >
                File jpeg, png, jpg, Max. file size: 2 MB
              </Typography.Text>
            </div>
            <Button
              icon={<Icon icon="solar:upload-minimalistic-bold-duotone" width="18" height="18" />}
            >
              Upload
            </Button>
          </Flex>
        </Upload>
      </Modal>
    </>
  )
}